import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  id: "video-player",
  class: "slide-media",
  muted: "",
  autoplay: "",
  playsinline: "",
  loop: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "video-player",
  class: "slide-media",
  muted: "",
  autoplay: "",
  playsinline: "",
  loop: ""
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  id: "video-player",
  class: "slide-media",
  muted: "",
  autoplay: "",
  playsinline: "",
  loop: ""
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  style: {"height":"100%"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 3,
  style: {"height":"100%"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper = _resolveComponent("swiper")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.useSlotAsSwiperSlides)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!$setup.delayLoading)
            ? (_openBlock(), _createBlock(_component_swiper, {
                key: 0,
                style: {"min-height":"150px","height":"15vh","width":"90vw","max-width":"400px"},
                navigation: true,
                id: $props.sliderId || 'card-swiper-slides',
                grabCursor: true,
                modules: $setup.modules,
                "slides-per-view": 1
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              }, 8, ["id", "modules"]))
            : _createCommentVNode("", true)
        ]))
      : ($props.homeBanners)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_swiper, {
              class: "responsive-swiper",
              id: "main-slides",
              pagination: true,
              navigation: true,
              modules: $setup.modules,
              "slides-per-view": 1,
              spaceBetween: 10,
              autoplay: { delay: 5000 },
              speed: 2000,
              loop: true,
              effect: 'fade'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _createElementVNode("video", _hoisted_3, [
                      _createElementVNode("source", {
                        src: require('@/assets/home/Home_FDMT_Tram_Car_Video.mp4'),
                        type: "video/mp4"
                      }, null, 8, _hoisted_4)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, { class: "slide-container" }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "slide-text" }, [
                      _createElementVNode("p", null, [
                        _createTextVNode("Data-driven career education"),
                        _createElementVNode("br"),
                        _createElementVNode("small", null, "across universities and secondary schools")
                      ])
                    ], -1)),
                    _createElementVNode("video", _hoisted_5, [
                      _createElementVNode("source", {
                        src: require('@/assets/home/Home_FDMT_Workshop_Teaching.mp4'),
                        type: "video/mp4"
                      }, null, 8, _hoisted_6)
                    ])
                  ]),
                  _: 1,
                  __: [0]
                }),
                _createVNode(_component_swiper_slide, { class: "slide-container" }, {
                  default: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "slide-text" }, [
                      _createElementVNode("p", null, [
                        _createTextVNode("500+ secondary school teachers help"),
                        _createElementVNode("br"),
                        _createTextVNode("connect passionate students")
                      ])
                    ], -1)),
                    _createElementVNode("img", {
                      class: "slide-media",
                      src: require('@/assets/home/Home_SecSchool_Teachers.jpg')
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1,
                  __: [1]
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _createElementVNode("video", _hoisted_8, [
                      _createElementVNode("source", {
                        src: require('@/assets/home/Home_FDMT_Blue_Tram_Car_Video.mp4'),
                        type: "video/mp4"
                      }, null, 8, _hoisted_9)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, { class: "slide-container" }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "slide-text" }, [
                      _createElementVNode("p", null, "AI-empowered career education")
                    ], -1)),
                    _createElementVNode("img", {
                      class: "slide-media",
                      src: require('@/assets/home/Home_AI_Empowered.jpg')
                    }, null, 8, _hoisted_10)
                  ]),
                  _: 1,
                  __: [2]
                }),
                _createVNode(_component_swiper_slide, { class: "slide-container" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "slide-media",
                      src: require('@/assets/website/banner.jpeg')
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modules"])
          ]))
        : _createCommentVNode("", true),
    ($props.videoIds)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_swiper, {
            id: "main-slides",
            pagination: true,
            navigation: true,
            modules: $setup.modules,
            "slides-per-view": 1,
            spaceBetween: 10,
            thumbs: { swiper: $setup.thumbsSwiper }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.videoIds, (vid) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: vid }, {
                  default: _withCtx(() => [
                    _createElementVNode("iframe", {
                      class: "responsive-embed",
                      style: {"width":"80%","height":"380px"},
                      src: `https://www.youtube.com/embed/${vid}`,
                      frameborder: "0",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_13)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules", "thumbs"]),
          _createVNode(_component_swiper, {
            onSwiper: $setup.setThumbsSwiper,
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            modules: $setup.modules
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.videoIds, (vid) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: vid }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
                    }, null, 8, _hoisted_14)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["onSwiper", "modules"])
        ]))
      : ($props.imageLinks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_swiper, {
              id: "main-slides",
              pagination: true,
              navigation: true,
              modules: $setup.modules,
              "slides-per-view": 1,
              spaceBetween: 10,
              thumbs: { swiper: $setup.thumbsSwiper }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.imageLinks, (imgLink) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, { key: imgLink }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", { src: imgLink }, null, 8, _hoisted_16)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modules", "thumbs"]),
            _createVNode(_component_swiper, {
              onSwiper: $setup.setThumbsSwiper,
              spaceBetween: 10,
              slidesPerView: 3,
              freeMode: true,
              watchSlidesProgress: true,
              modules: $setup.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.imageLinks, (imgLink) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, { key: imgLink }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", { src: imgLink }, null, 8, _hoisted_17)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["onSwiper", "modules"])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}